module.exports = __webpack_public_path__ + "img/mycrypto.af6ce52a.svg";